import { queryOptions } from '@tanstack/react-query';

import type { DrillDomainsQueryParams } from '~api/services';
import { drillDomainsService } from '~api/services';

/**
 * Create query options for fetching drill domains
 * @param params - Query parameters (pattern, crs)
 * @returns Query options for TanStack Query
 *
 * @example
 * const { data } = useQuery({
 *   ...drillDomainsQueryOptions({ pattern: '3WT_S173_530_120', crs: 'wgs' }),
 * });
 */
export const drillDomainsQueryOptions = (params: DrillDomainsQueryParams) =>
  queryOptions({
    queryKey: ['drill-domains', params.pattern, params.crs ?? 'local'],
    queryFn: () => drillDomainsService.getDrillDomains(params),
  });
